import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import useOnEventOutside from '../../hooks/useOnEventOutside';

import styles from './index.module.scss';

const Modal = ({ show, onClose, children }) => {
  const [isBrowser, setIsBrowser] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    setIsBrowser(true);
  }, []);

  useEffect(() => {
    if (show) {
      document.body.style.position = 'fixed';
    }
  }, [show]);

  useOnEventOutside(wrapperRef, () => onClose(), ['mousedown']);

  const handleCloseClick = (e) => {
    e.preventDefault();
    document.body.style.position = '';
    onClose();
  };

  const childrenWithProps = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { handleCloseClick });
    }
    return child;
  });

  const modalContent = show ? (
    <div className={styles.overlay}>
      <div className={styles.modal} ref={wrapperRef}>
        <div className={styles.body}>
          {childrenWithProps}
        </div>
      </div>
    </div>
  ) : null;

  if (isBrowser) {
    return ReactDOM.createPortal(
      modalContent,
      document.getElementById('modal-root')
    );
  }
  return null;
};

Modal.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  show: PropTypes.bool,
  onClose: PropTypes.func,
};

export default Modal;
